import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import translation from "./en/translation.json";
import ua from "./ua/translation.json";

export const resources = {
  ua: {
    translation: ua,
  },
  en: {
    translation,
  },
};

i18next.use(initReactI18next).init({
  fallbackLng: "ua", // if you're using a language detector, do not define the lng option
  debug: true,
  resources,
});
